/*! @pentacode/ui v0.1.0 */
// src/elements/table/table.types.ts
function e() {
	return (e) => e;
}
export { e as columnDef };

//# sourceMappingURL=table.types.js.map